import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoLayerModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoLayerModel._instance == null) GeoLayerModel._instance = new GeoLayerModel(authManager);
        return GeoLayerModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/geo-layers');

        this.entityName = 'geo-sections.GeoLayer';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Geological Layer';
        this.setLabel = 'Geological Layers';

        this.browser = {
            name: 'default-geo-sections-geolayer-browser',
            moduleName: 'default-geo-sections-geolayer-browser',
            moduleTitle: 'Geological Layers',
            moduleStateSlotName: 'default-geo-sections-geolayer-browser',
        };

        this.editor = {
            name: 'default-geo-sections-geolayer-editor',
            moduleName: 'default-geo-sections-geolayer-editor',
            moduleTitle: 'Geological Layer',
            moduleStateSlotName: 'default-geo-sections-geolayer-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'geoSectionId',
                type: 'GeoSection',
                persistent: true,
                label: 'Geological Section',
                description: 'geoLayer odpovídá vždy jen jedné geoSection, n:1',
            },
            {
                name: 'geoTypeId',
                type: 'GeoType',
                persistent: true,
                inEditor: true,
            },
            {
                name: 'elevationTop',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationOfZeroDatumLevel',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Elevation Of Zero Datum Level',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelTop',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Vertical Level Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelBottom',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Vertical Level Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'thickness',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Thickness',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
